import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'selected',
    viewPath: props.viewPath,
  })
  return function onClick() {
    submit({ type: 'close' })
  }
}

export function getTitle(value) {
  if (value?.length === 1) return `Move task "${value[0].title}" to...`

  return `Moving ${value?.length} tasks to...`
}

export function getDescription(value) {
  return `Boards shown are determined by assignee permissions, ${value?.length === 1 ? 'if the task is assigned.' : ' if the tasks are assigned.'} `
}
